const wowApp = require('angular').module('wowApp.shop');

wowApp.service('ShopPageStateService', ['$timeout', 'BreakpointsService', '$state', '$rootScope', '$document', 'MoveFocus', 'UserPreferenceService', 'ShopperService', 'AnimationsService', 'MemoScrollService', 'AtmService', '$injector', require('./shoppagestate-service')]);

wowApp.directive('wowPanels', ['BreakpointsService', 'FeatureService', 'SettingsByBreakpointService', 'ShopPageStateService', '$state', '$injector', require('./panels-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoppagestate/index.js
 **/